export default __webpack_public_path__ + "plus-square-837afc05a73198784b4385bb02c1e57e.svg";